import './built-config-a65ae98c.js';
import { a as getStoreHours } from './built-get-url-variant-a647ef33.js';

/**
 * Phone number field is currently in the format (555) 555-5555.
 * @TODO Consider adding a phone number formatting function in the future
 */
const getStores = () => Promise.resolve(
/** @type {Store[]} */
[
/**
 * 2020-04-16
 * Until further notice, we are hiding the Market St store
 */
// {
//   address_type: null,
//   city: 'San Francisco',
//   code: null,
//   company: 'Decathlon',
//   country: 'US',
//   email: 'customer.service@decathlon.com',
//   // ID from Shiphawk (for store finder)
//   id: 'adr_GezSSC9M',
//   // GID from shopify admin API
//   shopify_id: Number(
//     process.env.DECATHLON_STORE_MARKET_ST_ID || 247922697
//   ),
//   is_residential: false,
//   is_warehouse: false,
//   name: 'San Francisco',
//   phone_number: '(510) 221-6061',
//   state: 'CA',
//   street1: '735 Market St',
//   // Street 2 field used for hours data in ShipHawk setup.
//   street2: 'Open until 11:00 pm',
//   validated: false,
//   zip: '94103',
//   lat: 37.7865455,
//   lng: -122.4040965
// },
{
  address_type: 'destination',
  city: 'Emeryville',
  code: null,
  company: 'Decathlon',
  country: 'US',
  email: 'customer.service@decathlon.com',
  // ID from Shiphawk (for store finder)
  id: 'adr_K6s3Kaja',
  // GID from shopify admin API
  shopify_id: Number( 36556832840),
  is_residential: false,
  is_warehouse: false,
  name: 'Emeryville',
  phone_number: '(510) 210-1036',
  state: 'CA',
  street1: '3938 Horton St',
  // Street 2 field used for hours data in ShipHawk setup.
  street2: 'Grand Opening April 12th 9am',
  validated: false,
  zip: '94608',
  lat: 37.8292046,
  lng: -122.2869208,
  // Matches the Shopify Checkout radio input value
  pickupHandle: 'shopify-Emeryville Store Pickup-0.00',
  oneHourPickupHandle: 'shopify-1 Hour Pickup Emeryville-0.00'
}, {
  address_type: null,
  city: 'San Francisco',
  code: null,
  company: 'Decathlon',
  country: 'US',
  email: 'customer.service@decathlon.com',
  // ID from Shiphawk (for store finder)
  id: 'adr_sfpotrero',
  // GID from shopify admin API
  shopify_id: Number( 36556865608),
  is_residential: false,
  is_warehouse: false,
  name: 'SF Potrero',
  phone_number: '(628) 666-3005',
  state: 'CA',
  street1: '2300 16th St',
  // Street 2 field used for hours data in ShipHawk setup.
  street2: 'Opening November 2019',
  validated: false,
  zip: '94103',
  lat: 37.7659707,
  lng: -122.4079063,
  // Matches the Shopify Checkout radio input value
  pickupHandle: 'shopify-Potrero Store Pickup-0.00',
  oneHourPickupHandle: 'shopify-1 Hour Pickup Potrero-0.00'
}]);

// @ts-check
/**
 * Gets stores, applies hours logic, returns
 * @param {Object} config
 * @param {Boolean} [config.overrideHours] = false - True to override street2 value with a
 * specific message instead of today's hours
 */

async function fetchStores ({
  overrideHours
} = {
  overrideHours: false
}) {

  try {
    const stores = await getStores();
    const storesWithHours = stores.map(store => {
      const storeHours = getStoreHours(store.id);
      return Object.assign({}, store, {
        /**
         * Street 2 field used for hours data in ShipHawk setup.
         * @TODO When updating for final API decision from DE, change to 'today'
         * @see `scripts/store-finder/utilities/get-store-hours.js` for where
         * `storeHours.override` is set
         * @example: `if (storeId) { hoursOfOperation.override = 'msg'; }`
         */
        street2: overrideHours && storeHours.override ? storeHours.override : storeHours.today,
        tomorrow: storeHours.tomorrow
      });
    });
    return storesWithHours;
  } catch (error) {
    console.error('Error fetch stores: ', error);
    throw error;
  }
}

export { fetchStores as f, getStores as g };
